export const paymentLogos = {
  Mastercard: "https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg",
  PayPal: "https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg",
};

export const paymentMethods = [
  { id: 1, type: "Mastercard", last4: "3820", nextCharge: "14 Marzo 2025" },
  { id: 2, type: "PayPal", last4: "5820", nextCharge: "Nessun addebito programmato" },
  { id: 3, type: "Mastercard", last4: "5650", nextCharge: "12 Novembre 2025" },
  { id: 4, type: "PayPal", last4: "5650", nextCharge: "Nessun addebito programmato" },
];

export const metodiPagamentoMOCKUP = [
  {
    id: 1,
    descrizione: "Mastercard",
    logo: "https://upload.wikimedia.org/wikipedia/commons/a/a4/Mastercard_2019_logo.svg",
  },
  {
    id: 2,
    descrizione: "PayPal",
    logo: "https://upload.wikimedia.org/wikipedia/commons/b/b5/PayPal.svg",
  },
  {
    id: 3,
    descrizione: "Google",
    logo: "https://upload.wikimedia.org/wikipedia/commons/f/f2/Google_Pay_Logo.svg",
  },
  {
    id: 4,
    descrizione: "AmazonPay",
    logo: "https://upload.wikimedia.org/wikipedia/commons/2/29/Amazon_Pay_logo.svg",
  },
  {
    id: 5,
    descrizione: "Apple Pay",
    logo: "https://upload.wikimedia.org/wikipedia/commons/b/b0/Apple_Pay_logo.svg",
  },
  {
    id: 6,
    descrizione: "Satispay",
    logo: "https://upload.wikimedia.org/wikipedia/commons/archive/a/a5/20240507082457%21Logo_di_Satispay.svg",
  },
  {
    id: 7,
    descrizione: "Visa",
    logo: "https://upload.wikimedia.org/wikipedia/commons/5/5c/Visa_Inc._logo_%282021%E2%80%93present%29.svg",
  },
];

